"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ExternalResourceTypes = [
    'affiliation',
    'eligibility',
    'event',
    'membership',
    'organization',
    'profile',
    'registration',
    'registrationResult',
    'team',
];
